/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Link } from 'react-router';

import { getUrlTarget, formatDirectUrl } from 'helpers/ContentHelper';
import { FOOTER_PROMO, renderImage } from 'helpers/ImageHelper';

const Promos = props => {
  const { theme, promosPanels, breakpoint } = props;

  const renderLink = (linkProps, children) => <Link {...linkProps}>{children}</Link>;

  const getPromoItemData = item => {
    const { headline: itemHeadline, description: itemDescription, url } = item;
    const linkUrl = formatDirectUrl(url);
    const targetData = getUrlTarget(url);
    const imageSrc = _.get(item, 'images.promoImage');

    return {
      itemHeadline,
      itemDescription,
      linkUrl,
      imageSrc,
      ...targetData,
    };
  };

  const renderPromoContent = item => {
    const { itemHeadline, itemDescription, linkUrl: to, target, rel } = getPromoItemData(item);

    const linkProps = {
      className: theme.promoHeadlineLink,
      to,
      target,
      rel,
    };
    const linkElement = renderLink(linkProps, itemHeadline);

    const contentTag = (
      <div className={theme.promoContentContainer}>
        <div className={theme.promoHeadline}>{linkElement}</div>
        <div className={theme.promoDescription}>{itemDescription}</div>
      </div>
    );

    return contentTag;
  };

  const renderPromoImage = item => {
    const { itemDescription, linkUrl, target, rel, imageSrc } = this.getPromoItemData(item);

    if (!imageSrc) return null;
    const dynamicImage = renderImage({
      breakpoint,
      className: theme.promoImage,
      alt: itemDescription,
      imageType: FOOTER_PROMO,
      src: imageSrc,
    });
    const linkElement = renderLink({ to: linkUrl, target, rel }, dynamicImage);
    return <div className={theme.promoImageContainer}>{linkElement}</div>;
  };

  const renderPromoTags = item => {
    const { id: itemId } = item;
    const imageTag = renderPromoImage(item);
    if (!imageTag) return null;
    const contentTag = renderPromoContent(item);
    return (
      <div key={itemId} className={theme.promoContainer}>
        {imageTag}
        {contentTag}
      </div>
    );
  };

  if (!promosPanels) return null;
  const member = _.get(promosPanels, 'member');
  const promosTags = member.map(obj => {
    const { items, headline, id } = obj;
    if (!items) {
      return null;
    }
    const itemsMember = _.get(items, 'member');
    const promoTags = itemsMember.map(renderPromoTags);
    return (
      <div key={id}>
        <div className={theme.promosHeadline}>{headline}</div>
        {promoTags}
      </div>
    );
  });
  const promos = promosTags && <div>{promosTags}</div>;
  return <div className={theme.promosContainer}>{promos}</div>;
};

Promos.propTypes = {
  breakpoint: PropTypes.string,
  promosPanels: PropTypes.shape({}),
  theme: PropTypes.shape({}),
};

export default Promos;
